

































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import HorizontalBarChart from '@/views/presentation/components/charts/HorizontalBarChart.vue';
import WInlineEdit from '@/components/WInlineEdit.vue';
import DoughnutChart from '@/views/presentation/components/charts/DoughnutChart.vue';
import VerticalBarChart from '@/views/presentation/components/charts/VerticalBarChart.vue';
import PieChart from '@/views/presentation/components/charts/PieChart.vue';
import { CreateSurveyElement } from '@/models/Presentation';
import { sum } from 'lodash';
import { BFormInput } from 'bootstrap-vue';

@Component({
  components: { PieChart, VerticalBarChart, DoughnutChart, WInlineEdit, HorizontalBarChart }
})
export default class SurveyPreviewResults extends Vue {

  @Prop() surveyElement!: CreateSurveyElement;
  @Prop() editable!: boolean;
  @Prop({ default: false }) large!: boolean;
  @Prop({ default: null }) validations!: any | null;

  titleEdit = false;
  descriptionEdit = false;

  containerSize = { width: 0, height: 0 };

  values: number[] = [];
  totalData = 0;
  answerlength = 0;
  chartType = 'BAR_CHART_V';

  get defaultFontSize() {
    return this.containerSize.width < 450 ? '0.7rem' : '1rem';
  }

  mounted() {
    this.values = this.surveyElement.answers.map(() => Math.round(Math.random() * 80 + 20));
    this.totalData = sum(this.values);
    this.answerlength = this.surveyElement.answers.length;
    this.chartType = this.surveyElement.chartType;

    const container = this.$refs.container as HTMLElement;
    if (!container) return;

    const resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        this.containerSize.width = entry.contentRect.width;
        this.containerSize.height = entry.contentRect.height;
      }
    });

    resizeObserver.observe(container);
  }

  @Watch('surveyElement', { deep: true })
  onSurveyElementChange() {
    if (this.surveyElement.answers.length != this.answerlength || this.surveyElement.chartType != this.chartType) {
      this.values = this.surveyElement.answers.map(() => Math.round(Math.random() * 80 + 20));
      this.totalData = sum(this.values);
      this.answerlength = this.surveyElement.answers.length;
      this.chartType = this.surveyElement.chartType;
    }
  }

  editTitle(): void {
    if (!this.editable) {
      return;
    }
    this.titleEdit = true;
    setTimeout(() => {
      (this.$refs['title-input'] as BFormInput).focus();
    }, 50);
  }

  editDescription(): void {
    if (!this.editable) {
      return;
    }
    this.descriptionEdit = true;
    setTimeout(() => {
      (this.$refs['description-input'] as BFormInput).focus();
    }, 50);
  }

}
